import React, { useState } from 'react';
import axios from 'axios';
import './AdminLoginCard.css';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const backEndURL = process.env.REACT_APP_BACKEND_URL;

const AdminLoginCard = () => {
	const [formData, setFormData] = useState({
		email: '',
		password: '',
	});
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();

	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData({ ...formData, [name]: value });
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setLoading(true);

		try {
			const response = await axios.post(`${backEndURL}/admin/login`, formData);

			localStorage.clear();

			const data = response.data;
			localStorage.setItem('adminToken', data.adminToken);

			toast.success(data.message || "Registered Successfull..!", {
				position: "top-center",
				theme: "dark",
			});
			navigate('/articles');
		} catch (err) {
			toast.error(err.response?.data?.message || 'An error occurred during login. Please try again.', {
				position: "top-center",
				theme: "dark",
			});
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="adminLoginCard">
			<form onSubmit={handleSubmit} className="loginForm">
				<h2>Admin Login</h2>
				<div className="formField">
					<label htmlFor="email">Email</label>
					<input
						type="email"
						name="email"
						id="email"
						placeholder="Enter admin email"
						value={formData.email}
						onChange={handleChange}
						required
					/>
				</div>
				<div className="formField">
					<label htmlFor="password">Password</label>
					<input
						type="password"
						name="password"
						id="password"
						placeholder="Enter admin password"
						value={formData.password}
						onChange={handleChange}
						required
					/>
				</div>
				<button type="submit" className="loginButton" disabled={loading}>
					{loading ? (
						<div className="dotContainer">
							<span className="dot"></span>
							<span className="dot"></span>
							<span className="dot"></span>
						</div>
					) : (
						"Register"
					)}
				</button>
			</form>
		</div>
	);
};

export default AdminLoginCard;
